import { render } from "./ResolveDefect.vue?vue&type=template&id=3d5919c6"
import script from "./ResolveDefect.vue?vue&type=script&lang=js"
export * from "./ResolveDefect.vue?vue&type=script&lang=js"

import "./ResolveDefect.vue?vue&type=style&index=0&id=3d5919c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__